import Neva1 from "../assets/images/news/neva.png";
import Neva2 from "../assets/images/news/Neva1.jpg";
import Neva3 from "../assets/images/news/Neva2.jpg";
import Neva4 from "../assets/images/news/Neva3.jpg";

import Baikal1 from "../assets/images/news/baikal-1.png";
import Baikal2 from "../assets/images/news/baikal-2.png";
import Baikal3 from "../assets/images/news/baikal-3.png";

import L9g20_1 from "../assets/images/l9g20/L-9g20-1.png";
import L9g20_2 from "../assets/images/l9g20/L-9g20-2.png";
import L9g20_3 from "../assets/images/l9g20/L-9g20-3.png";
import L9g20_4 from "../assets/images/l9g20/L-9g20-4.png";

import Quanto1 from "../assets/images/news/Quanto1.png";
import Quanto2 from "../assets/images/news/Quanto2.png";
import Quanto3 from "../assets/images/news/Quanto3.png";
import Quanto4 from "../assets/images/news/Quanto4.png";

import Marintec2025 from "../assets/images/news/marintec2025.jpg";

export const newsData = (t) => [
    {
      id: 1,
      title: t('news.article1.title'),
      date: t('news.article1.date'),
      excerpt: t('news.article1.excerpt'),
      image: Baikal1,
      images: [
        "https://www.jinr.ru/wp-content/uploads/2024/02/Baikal-GVD-1.jpg",
        Baikal1,
        "https://minio.nplus1.ru/app-images/757688/63f642d92db40_img_tablet.jpg",
        Baikal2,
        "https://www.jinr.ru/wp-content/uploads/2024/02/Baikal-GVD-2.jpg",
        Baikal3
      ],
       content: [
        { type: 'paragraph', text: t('news.article1.fullText.p1') },
        { type: 'paragraph', text: t('news.article1.fullText.p2') },
        { type: 'paragraph', text: t('news.article1.fullText.p3') }
      ]
    },
    {
      id: 2,
      title: t('news.article2.title'),
      date: t('news.article2.date'),
      excerpt: t('news.article2.excerpt'),
      image: L9g20_1,
      images: [
        L9g20_1,
        L9g20_2,
        L9g20_3,
        L9g20_4
      ],
      content: [
        { type: 'paragraph', text: t('news.article2.fullText.p1') },
        { type: 'paragraph', text: t('news.article2.fullText.p2') },
        { type: 'paragraph', text: t('news.article2.fullText.p3') },
        { type: 'bulletList', items: [
          t('news.article2.fullText.p3_1'),
          t('news.article2.fullText.p3_2'),
          t('news.article2.fullText.p3_3'),
          t('news.article2.fullText.p3_4'),
          t('news.article2.fullText.p3_5')
        ]},
        { type: 'paragraph', text: t('news.article2.fullText.p4') },
        { type: 'read_more', read_more_link: "/accessoires#l9g20"}
      ]
    },
    {
      id: 3,
      title: t('news.article3.title'),
      date: t('news.article3.date'),
      excerpt: t('news.article3.excerpt'),
      image: Neva1,
      images: [
        Neva1,
        Neva2,
        Neva3,
        Neva4 
      ],
      content: [
        { type: 'paragraph', text: t('news.article3.fullText.p1') },
        { type: 'paragraph', text: t('news.article3.fullText.p2') },
        { type: 'paragraph', text: t('news.article3.fullText.p3') },
        { type: 'paragraph', text: t('news.article3.fullText.p4') }
      ]
    },
    {
      id: 4,
      title: t('news.article4.title'),
      date: t('news.article4.date'),
      excerpt: t('news.article4.excerpt'),
      image: Quanto2,
      images: [
        Quanto1,
        Quanto2,
        Quanto3,
        Quanto4
      ],
      content: [
        { type: 'paragraph', text: t('news.article4.fullText.p1') },
        { type: 'paragraph', text: t('news.article4.fullText.p2') },
        { type: 'paragraph', text: t('news.article4.fullText.p3') },
        { type: 'paragraph', text: t('news.article4.fullText.p4') },
        { type: 'read_more', read_more_link: "/acoustic_modems#product-list-quanta"}
      ]
    },
    {
      id: 5,
      title: t('news.article5.title'),
      date: t('news.article5.date'),
      excerpt: t('news.article5.excerpt'),
      image: Marintec2025,
      images: [
        Marintec2025
      ],
      content: [
        { type: 'paragraph', text: t('news.article5.fullText.p1') },
        { type: 'paragraph', text: t('news.article5.fullText.p2') },
        { type: 'paragraph', text: t('news.article5.fullText.p3') },
        { type: 'paragraph', text: t('news.article5.fullText.p4') }
      ]
    }
];
